import React from 'react';
import PropTypes from 'prop-types';
import { Digits, Title } from '../../common';

export default function ConfirmNewPassword({ onChange, values, color }) {
  return (
    <>
      <Title marginBottom="44px">Confirme sua senha</Title>
      <Digits
        type="password"
        label="Digite novamente para confirmar"
        onChange={objValue => onChange(objValue, 'new_password_confirmation')}
        values={values}
        color={color}
      />
    </>
  );
}

ConfirmNewPassword.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.object,
};
